import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_013.jpg';
page.images = [
  {
    imageId: 'page013_zoom0',
    rectangle: {
      x: 152,
      y: 1732,
      width: 1156,
      height: 578,
    },
    imageSrc: 'images/page013/013 2.jpg',
  },
  {
    imageId: 'page013_zoom1',
    rectangle: {
      x: 604,
      y: 123,
      width: 1040,
      height: 1178,
    },
    imageSrc: 'images/page013/013 1.jpg',
  },
];
page.games = [
  {
    id: 'page013_game5',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 333,
    },
    item: {
      id: 'page013_game5',
    },
    rectangle: {
      id: 'page013_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page013_rect0',

    tooltip: '',

    linked: ['page013_game5'],
    x: 131,
    y: 333,
    width: 423,
    height: 910,
  },
];
export default page;
